import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import List from './views/List.vue'
import Items from './views/Items.vue'
import NotFound from './views/NotFound.vue'
import store from './store';

Vue.use(Router)

const router  = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        page: 1,
        headState: 'search'
      }
    },
    {
      path: '*',
      name:'404',
      component: NotFound,
      meta: {
        page: 2,
        headState: 'search'
      }

    },
    {
      path: '/about/',
      name: 'about',
      component: () => import( './views/About.vue'),
      meta: {
        page: 2,
        headState: 'title'
      }
    },
    {
      path: '/privacy/',
      name: 'privacy',
      component: () => import( './views/Privacy.vue'),
      meta: {
        page: 2,
        headState: 'title'
      }
    },
    {
      path: '/search/',
      name: 'search',
      component: () => import( './views/Search.vue'),
      meta: {
        page: 2,
        headState: 'search'
      }
    },
    {
      path: '/items/',
      component: List,
      name: 'itemList',
      meta: {
        page: 2,
        headState: 'search'
      }
    },
    {
      path: '/items/:id',
      name: 'itemDetail',
      component: Items,
      meta: {
        page: 3,
        headState: 'title'
      }
    },
    {
      path: '/brand/:code',
      component: () => import( './views/Brand.vue'),
      name: 'BrandDetail',
      meta: {
        page: 2,
        headState: 'search'
      },
    },
    {
      path: '/brand/:code/items/',
      component: () => import( './views/Brand.vue'),
      name: 'BrandItems',
      meta: {
        page: 2,
        headState: 'search'
      },
    },
    {
      path: '/brand/:brand/items/:gender/:category',
      component: List,
      name: 'BrandItemsCatGen',
      meta: {
        page: 2,
        headState: 'search'
      },
    },
    {
      path: '/viewed/',
      component: () => import( './views/Viewed.vue'),
      name: 'Viewed',
      meta: {
        page: 2,
        headState: 'search'
      },
    },
    {
      path: '/categories/',
      component: () => import( './views/Category.vue'),
      name: 'Category',
      meta: {
        page: 2,
        headState: 'title'
      },
    },
    {
      path: '/categories/:category/:gender',
      component: List,
      name: 'CategoryItems',
      meta: {
        page: 2,
        headState: 'search'
      },
    },


  ]
})
export default router;

router.afterEach((to) =>{
  store.dispatch('changePage', to.meta)
  // gtag('config', 'UA-50550476-8', {'page_path': to.path});
  // console.log('呼ばれたよ!')
})
